import { monthlyPulletDetails } from "../pullet/actions";
import {
  PULLET_INVENTORY_DETAILS_BASE_ON_MONTH_FAIL,
  PULLET_INVENTORY_DETAILS_BASE_ON_MONTH_REQUEST,
} from "../pullet/actionType";
import axios from "./utils/axios";

const fetchMonthlyPulletDetails = (monthId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PULLET_INVENTORY_DETAILS_BASE_ON_MONTH_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.get(
        `api/pullet/details-month/${monthId}/`,
        config
      );
      dispatch(monthlyPulletDetails(data));
    } catch (error) {
      dispatch({
        type: PULLET_INVENTORY_DETAILS_BASE_ON_MONTH_FAIL,
        payload:
          error.response && error.response.data.details
            ? error.response.data.details
            : error.message,
      });
    }
  };
};
export default fetchMonthlyPulletDetails;
